<template>
  <image mode="heightFix" class="slogan" src="{{ sloganIcon }}"/>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    properties: {
      sloganIcon: {
        type: String,
        value: 'https://ut-static.udache.com/webx/sfc/_jWcnvtaRWLUN5uv8DYS6.png'
      }
    },
  })
</script>

<style lang="stylus" scoped>
  .slogan
    display block
    height 35px
    margin 0 auto 20px
</style>